import Vue from "vue";
import Component from "vue-class-component";
import { ListResponse } from "@/models/grids/list.response";
import { DataTableHeader } from "vuetify";
import { Watch } from "vue-property-decorator";

export interface DataServerGridTableHeader<T extends any = any>
  extends DataTableHeader {
  filterItem?: any;
}

export class DataServerGridOptions {
  inited: boolean = false;
  page: number = 1;
  pageSize: number = 10;
  total: number = 0;
  data: any[] = [];
  columns: DataServerGridTableHeader[] = [];
  loading: boolean = false;
}

@Component
export class ServerGrid extends Vue {
  gridConfigs!: DataServerGridOptions;

  @Watch("$route.query.skip")
  onGridRouteSkipChanged() {
    if (!this.$route.query.skip) {
      this.gridConfigs.page = 1;
    } else {
      let p =
        parseInt(this.$route.query.skip as string) / this.gridConfigs.pageSize;
      p = p + 1;
    }
  }

  get hasGridFilters(): boolean {
    return (
      this.gridConfigs.columns.find((i: DataTableHeader) => i.filterable) !=
      null
    );
  }

  get pageCount(): number {
    return Math.ceil(this.gridConfigs.total / this.gridConfigs.pageSize);
  }

  GridLoad(list: ListResponse<any>): void {
    this.gridConfigs.data = list.data;
    this.gridConfigs.total = list.total;
  }

  GridClear(): void {
    this.gridConfigs.total = 0;
    this.gridConfigs.data = [];
  }

  GridSetLoading(loading: boolean): void {
    this.gridConfigs.loading = loading;
  }

  GridInit() {
    if (this.$route.query) {
      if (this.$route.query.take) {
        this.gridConfigs.pageSize = parseInt(this.$route.query.take as string);
      }
      if (this.$route.query.skip) {
        let p =
          parseInt(this.$route.query.skip as string) /
          this.gridConfigs.pageSize;
        p = p + 1;
        this.gridConfigs.page = p;
      }
    }
    this.gridConfigs.inited = true;
  }

  GridFilter(header: DataServerGridTableHeader) {
    if (this.gridConfigs.page <= 1) {
      const p = Object.assign({}, this.$route.query, { skip: 0 });
      p[header.value] = header.filterItem;
      this.$router.push({ query: p });
    } else {
      this.gridConfigs.page = 1;
    }
  }

  GridClearFilter(header: DataServerGridTableHeader) {
    header.filterItem = "";
    this.GridFilter(header);
  }

  GridPagesizeChanged() {
    this.onGridOptionsChange();
  }

  GridPageChanged() {
    this.onGridOptionsChange();
  }

  onGridOptionsChange() {
    if (this.gridConfigs.inited) {
      const p = Object.assign({}, this.$route.query, {
        skip: (this.gridConfigs.page - 1) * this.gridConfigs.pageSize,
        take: this.gridConfigs.pageSize
      });
      // TODO Compare with previus route
      // const pQuery = Object.keys(p)
      //   .map(key => key + (p[key] ? "=" + p[key] : ""))
      //   .join("&");
      // const routeQuery = this.$route.fullPath.split("?")[1];
      // console.log([routeQuery, pQuery]);
      // if (pQuery !== routeQuery) {
      //   console.log("Do sometinng");
      //   //this.$router.push({ query: p }).catch();
      // }

      this.$router.push({ query: p }).catch(() => {
        console.log("duplicated");
      });
    }
  }
}
